var React = require('react');

function PlayCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 22.54C17.5228 22.54 22 18.0629 22 12.54C22 7.01719 17.5228 2.54004 12 2.54004C6.47715 2.54004 2 7.01719 2 12.54C2 18.0629 6.47715 22.54 12 22.54Z","fill":"white","fillOpacity":"0.1","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10 8.54004L16 12.54L10 16.54V8.54004Z","fill":"white","key":1})]);
}

PlayCircle.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = PlayCircle;

PlayCircle.default = PlayCircle;
